/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Report_DescInputs */



/**
* | output |
* | --- |
* | "After the conversation, a draft report is ready and waiting. Wundo tracks the follow-up actions until they're done." |
*
* @param {Onboarding_Value_Report_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_report_desc = /** @type {((inputs?: Onboarding_Value_Report_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Report_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Na het gesprek staat er een concept-verslag klaar. Actiepunten houdt Wundo bij tot ze afgerond zijn.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Après la conversation, un projet de compte rendu vous attend. Wundo suit les points d'action jusqu’à ce qu’ils soient terminés.")
	return /** @type {LocalizedString} */ ("After the conversation, a draft report is ready and waiting. Wundo tracks the follow-up actions until they're done.")
});